import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';
import { captureException } from '@sentry/browser';
import { BackButton } from './BackButton';
import { BadgesSort } from './BadgesSort';
import { Clipboard } from './Clipboard';
import { CssLoad } from './CssLoad';
import { Drawer } from './Drawer';
import { Dropdown } from './Dropdown';
import { EmojiPicker } from './EmojiPicker';
import { ExitSurvey } from './ExitSurvey';
import { Gallery } from './Gallery';
import { GtmDataLayer } from './GtmDataLayer';
import { IframePlayer } from './IframePlayer';
import { InfiniteScroll } from './InfiniteScroll';
import { LinkShare } from './LinkShare';
import { LoginWithFourthwall } from './LoginWithFourthwall';
import { Logout } from './Logout';
import { Mailcheck } from './Mailcheck';
import { Modal } from './Modal';
import { MuxPlayer } from './MuxPlayer';
import { NotificationModal } from './NotificationModal';
import { Popover } from './Popover';
import { QrCode } from './QrCode';
import { ScrollOnFocus } from './ScrollOnFocus';
import { ScrollSave } from './ScrollSave';
import { ScrollToElement } from './ScrollToElement';
import { ScrollToTop } from './ScrollToTop';
import { Slider } from './Slider';
import { Spoiler } from './Spoiler';
import { SrcChange } from './SrcChange';
import { SubmitEnabler } from './SubmitEnabler';
import { Toast } from './Toast';
import { Toggle } from './Toggle';
import { Tooltip } from './Tooltip';
import { TurboFrameHistory } from './TurboFrameHistory';
import { TurboFrameReload } from './TurboFrameReload';
import { UnsavedChanges } from './UnsavedChanges';
import { VimeoPlayer } from './VimeoPlayer';
import { WindowHeight } from './WindowHeight';
import { WlaDownloadsLink } from './WlaDownloadsLink';
import { WlaMessagesIcon } from './WlaMessagesIcon';
import { WlaPassword } from './WlaPassword';
import { WlaPostDownload } from './WlaPostDownload';
import { YoutubePlayer } from './YoutubePlayer';
window.Stimulus = Application.start();
window.Stimulus.register('back-button', BackButton);
window.Stimulus.register('badges-sort', BadgesSort);
window.Stimulus.register('clipboard', Clipboard);
window.Stimulus.register('css-load', CssLoad);
window.Stimulus.register('drawer', Drawer);
window.Stimulus.register('dropdown', Dropdown);
window.Stimulus.register('emoji-picker', EmojiPicker);
window.Stimulus.register('exit-survey', ExitSurvey);
window.Stimulus.register('gallery', Gallery);
window.Stimulus.register('gtm-data-layer', GtmDataLayer);
window.Stimulus.register('iframe-player', IframePlayer);
window.Stimulus.register('infinite-scroll', InfiniteScroll);
window.Stimulus.register('link-share', LinkShare);
window.Stimulus.register('login-with-fourthwall', LoginWithFourthwall);
window.Stimulus.register('logout', Logout);
window.Stimulus.register('mailcheck', Mailcheck);
window.Stimulus.register('modal', Modal);
window.Stimulus.register('mux-player', MuxPlayer);
window.Stimulus.register('notification-modal', NotificationModal);
window.Stimulus.register('popover', Popover);
window.Stimulus.register('qr-code', QrCode);
window.Stimulus.register('scroll-on-focus', ScrollOnFocus);
window.Stimulus.register('scroll-save', ScrollSave);
window.Stimulus.register('scroll-to-element', ScrollToElement);
window.Stimulus.register('scroll-to-top', ScrollToTop);
window.Stimulus.register('slider', Slider);
window.Stimulus.register('spoiler', Spoiler);
window.Stimulus.register('src-change', SrcChange);
window.Stimulus.register('submit-enabler', SubmitEnabler);
window.Stimulus.register('toast', Toast);
window.Stimulus.register('toggle', Toggle);
window.Stimulus.register('tooltip', Tooltip);
window.Stimulus.register('turbo-frame-history', TurboFrameHistory);
window.Stimulus.register('turbo-frame-reload', TurboFrameReload);
window.Stimulus.register('unsaved-changes', UnsavedChanges);
window.Stimulus.register('vimeo-player', VimeoPlayer);
window.Stimulus.register('window-height', WindowHeight);
window.Stimulus.register('wla-downloads-link', WlaDownloadsLink);
window.Stimulus.register('wla-messages-icon', WlaMessagesIcon);
window.Stimulus.register('wla-password', WlaPassword);
window.Stimulus.register('wla-post-download', WlaPostDownload);
window.Stimulus.register('youtube-player', YoutubePlayer);
const defaultErrorHandler = window.Stimulus.handleError.bind(window.Stimulus);
window.Stimulus.load(definitionsFromContext(require.context('.', true, /_controller\.(js|ts)$/)));
window.Stimulus.load(definitionsFromContext(require.context('./shipping_address', true, /_controller\.(js|ts)$/)));
window.Stimulus.handleError = (error, message, detail = {}) => {
    defaultErrorHandler(error, message, detail);
    captureException(error);
};
